module.exports = __webpack_public_path__ + "img/Symbol2.ade27952.svg";